import React, { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { collection, onSnapshot, orderBy, query, where } from 'firebase/firestore'
import { FaAnglesLeft } from 'react-icons/fa6'
import { db } from '../../../firebase'


import { motion, AnimatePresence } from 'framer-motion';

const ProjectsBlog = () => {
  const [projects, setProjects] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("ALL");

  const categories = ["ALL", "Brand", "Creation", "Event & Experience"];

  useEffect(() => {
    const readProjectsData = async () => {
      let projectsRef = query(
        collection(db, 'projects'),
        orderBy('createdAt', 'desc'),
        where('isVisible', '==', true)
      );

      if (selectedCategory !== "ALL") {
        projectsRef = query(
          collection(db, 'projects'),
          orderBy('createdAt', 'desc'),
          where('projectType', '==', selectedCategory),
          where('isVisible', '==', true)
        );
      }

      const unsubscribe = onSnapshot(projectsRef, (snapshot) => {
        setProjects(snapshot.docs.map(doc => ({
          id: doc.id,
          data: doc.data()
        })));
      });

      return () => unsubscribe();
    };

    readProjectsData();
  }, [selectedCategory]);

  const navigate = useNavigate();

  return (
    <div className='flex flex-col gap-[30px] w-full min-h-screen bg-black lg:p-[5rem] p-[1.25rem]'>

      <p className="font-agrandir xl:text-[24px] text-[16px] text-white">Work</p>
      <section className="flex pb-[30px]" id='blog'>

        <div className="flex justify-start items-center">
          <Link onClick={() => navigate(-1)} className="font-pressura flex items-center text-aqua text-[14px]">
            <FaAnglesLeft className='text-[10px]' />
            Back
          </Link>
        </div>

      </section>


      {/* Catégories (Filtres) */}
      <motion.div
        id='categories'
        className="flex gap-5 mt-5 lg:ml-10 ml-5 overflow-x-scroll ppmori uppercase w-full"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.3 }}
      >
        {categories.map((cat, idx) => (
          <motion.p
            key={idx}
            className={`lg:text-[12px] text-[16px] cursor-pointer transition-all duration-200 ${selectedCategory === cat ? 'text-white font-bold' : 'text-lightgrey3'}`}
            onClick={() => setSelectedCategory(cat)}
            whileHover={{ scale: 1.05 }}
          >
            {cat}
          </motion.p>
        ))}
      </motion.div>

      {/* Liste des Projets */}
      <motion.div
        className="grid lg:grid-cols-3 items-stretch gap-10 grid-cols-1 lg:mt-0"
        initial="hidden"
        animate="visible"
        variants={{
          visible: {
            transition: {
              staggerChildren: 0.15
            }
          }
        }}
      >
        {projects.length > 0 ? (
          <AnimatePresence>
            {projects.map((project, idx) => (
              <motion.div
                key={idx}
                variants={{
                  hidden: { opacity: 0, scale: 0.95 },
                  visible: { opacity: 1, scale: 1 }
                }}
                exit={{ opacity: 0, scale: 0.9 }}
                transition={{ duration: 0.5 }}
              >
                <Link to={`projectview/${project.id}`} className="flex flex-col gap-1">
                  <div
                    className="flex w-full aspect-[4/5] bg-darkgrey bg-cover bg-no-repeat bg-center rounded-[10px]"
                    style={{ backgroundImage: `url(${project.data.coverUrl})` }}
                  />
                  <div className="flex items-center justify-between w-full px-[0.1rem] text-white">
                    <p className="flex flex-col">{project.data.projectName}</p>
                    <p className="flex gap-2.5 items-center justify-center">{project.data.year}</p>
                  </div>
                </Link>
              </motion.div>
            ))}
          </AnimatePresence>
        ) : (
          <motion.p
            className="text-white text-center w-full mt-10"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.5 }}
          >
            Aucun projet trouvé pour cette catégorie.
          </motion.p>
        )}
      </motion.div>

      <div className="flex gap-5 fixed bottom-10 right-[30px] ">
        <Link to={"/dashboard/projectapp/new-project"} className='buttonblack border-white border'>Nouveau projet</Link>
        <Link to={"/dashboard/projectapp/archives"} className='buttonblack border-white border'>Archives</Link>
      </div>

    </div>
  );
};

export default ProjectsBlog;